// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation, useParams } from "react-router-dom";
// const API_URL = process.env.REACT_APP_API_URL;
// const OccupancyTransferAdd = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { id } = useParams();
//   const isEdit = !!id;

//   const [form, setForm] = useState(getInitialForm());
  
//   const [errors, setErrors] = useState({});
//   const [successMessage, setSuccessMessage] = useState("");
//   const [banks, setBanks] = useState([]);
//   const [loading, setLoading] = useState(false);

//   /* ================= POPULATE FORM ================= */
// const populateForm = (record) => {
//   const known = ["Residential", "Commercial", "Residential + Commercial"];
//   const isKnown = known.includes(record.fee_type);

//   setForm({
//     ...getInitialForm(),
//     receipt_no: record.receipt_no || "",
//     receipt_date: record.receipt_date?.slice(0, 10) || today(),
//     challan_no: record.challan_no || "",
//     rbi_challan_no: record.rbi_challan_no || "",
//     challan_date: record.challan_date?.slice(0, 10) || today(),
//     payee_name: record.payee_name || "",
//     fee_type: isKnown ? record.fee_type : "Other",
//     custom_fee_type: isKnown ? "" : (record.fee_type || ""),
//     amount: record.amount ? String(record.amount) : "",
//     amount_words: record.amount_words || (record.amount ? numberToWords(record.amount) : ""),
//     payment_mode: record.payment_mode || "",
//     dd_cheque_number: record.dd_cheque_number || "",
//     dd_date: record.dd_date?.slice(0, 10) || today(),
//     bank_name: record.bank_name || "",
//     contact_number: record.contact_number || "",
//     remark: record.remark || "",
//   });
// };

//   /* ================= LOAD RECORD FOR EDIT ================= */
//   useEffect(() => {
//     if (!isEdit) return;

//     const loadRecord = async () => {
//       setLoading(true);

//       if (location.state?.record) {
//         populateForm(location.state.record);
//         setLoading(false);
//         return;
//       }

//       try {
//         const res = await fetch(`${API_URL}/api/occupancy-transfer/${id}`);
//         if (!res.ok) throw new Error("Failed to fetch");
//         const record = await res.json();
//         populateForm(record);
//       } catch (err) {
//         console.error(err);
//         setErrors({ general: "Failed to load record data." });
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadRecord();
//   }, [isEdit, id]);

//   /* ================= FETCH BANKS ================= */
//   useEffect(() => {
//     fetch(`${API_URL}/api/occupancy-transfer/banks`)
//       .then(res => res.json())
//       .then(data => {
//         if (Array.isArray(data)) setBanks(data);
//         else setBanks([]);
//       })
//       .catch(err => console.error(err));
//   }, []);


// const FEE_AMOUNTS = {
//   "Residential": "40000",
//   "Commercial": "60000",
//   "Residential + Commercial": "100000",
// };

// const today = () => new Date().toISOString().split("T")[0];

// const numberToWords = (num) => {
//   if (!num) return "";
//   const a = ["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
//   const b = ["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];

//   const inWords = (n) => {
//     if (n < 20) return a[n];
//     if (n < 100) return b[Math.floor(n / 10)] + " " + a[n % 10];
//     if (n < 1000) return a[Math.floor(n / 100)] + " Hundred " + inWords(n % 100);
//     if (n < 100000) return inWords(Math.floor(n / 1000)) + " Thousand " + inWords(n % 1000);
//     return inWords(Math.floor(n / 100000)) + " Lakh " + inWords(n % 100000);
//   };

//   return (inWords(parseInt(num)) + " Rupees Only").replace(/\s+/g, " ").trim();
// };

// const getInitialForm = () => ({
//   receipt_no: "",
//   receipt_date: today(),
//   challan_no: "",
//   rbi_challan_no: "",
//   challan_date: today(),
//   payee_name: "",
//   fee_type: "Residential",
//   custom_fee_type: "",
//   amount: FEE_AMOUNTS["Residential"],           // default 40000
//   amount_words: numberToWords(FEE_AMOUNTS["Residential"]),
//   payment_mode: "",
//   dd_cheque_number: "",
//   dd_date: today(),
//   bank_name: "",
//   contact_number: "",
//   remark: "",
// });
//   /* ================= HANDLE CHANGE ================= */
//  /* ================= HANDLE CHANGE ================= */
// const handleChange = (e) => {
//   const { name, value } = e.target;
//   let updated = { ...form, [name]: value };

//   if (name === "fee_type") {
//     if (FEE_AMOUNTS[value]) {
//       // Auto-sync amount
//       updated.amount = FEE_AMOUNTS[value];
//       updated.amount_words = numberToWords(FEE_AMOUNTS[value]);
//       updated.custom_fee_type = "";
//     } else if (value === "Other") {
//       // Manual entry
//       updated.amount = "";
//       updated.amount_words = "";
//     } else {
//       updated.amount = "";
//       updated.amount_words = "";
//     }
//   }

//   if (name === "amount") {
//     updated.amount_words =
//       value !== "" && !isNaN(value) && Number(value) > 0 ? numberToWords(value) : "";
//   }

//   setForm(updated);
//   if (errors[name] || errors.general) {
//     setErrors((prev) => {
//       const newErrors = { ...prev };
//       delete newErrors[name];
//       delete newErrors.general;
//       return newErrors;
//     });
//   }
// };

//   /* ================= VALIDATION ================= */
// /* ================= VALIDATION ================= */
// const validate = () => {
//   let err = {};

//   // Challan No
//   if (!form.challan_no?.trim()) {
//     err.challan_no = "Challan number is required";
//   } else if (!/^[a-zA-Z0-9/-]+$/.test(form.challan_no.trim())) {
//     err.challan_no = "Challan number can only contain letters, numbers, / and -";
//   }

//   // RBI Challan No
//   if (form.rbi_challan_no?.trim() && !/^[a-zA-Z0-9/-]+$/.test(form.rbi_challan_no.trim())) {
//     err.rbi_challan_no = "RBI Challan number can only contain letters, numbers, / and -";
//   }

//   // Payee Name — & IS ALLOWED
//   if (!form.payee_name?.trim()) {
//     err.payee_name = "Payee name is required";
//   } else if (form.payee_name.trim().length < 3) {
//     err.payee_name = "Payee name must be at least 3 characters";
//   } else if (form.payee_name.trim().length > 100) {
//     err.payee_name = "Payee name cannot exceed 100 characters";
//   } else if (!/^[a-zA-Z0-9\s.&'()-]+$/.test(form.payee_name.trim())) {
//     err.payee_name = "Payee name contains invalid characters. Only letters, numbers, spaces, &, ., ', (, ), - are allowed";
//   }
//   // Receipt No
//   // ADD inside validate():
// if (!form.receipt_no?.trim()) {
//   err.receipt_no = "Receipt number is required";
// } else if (!/^[a-zA-Z0-9/-]+$/.test(form.receipt_no.trim())) {
//   err.receipt_no = "Receipt number can only contain letters, numbers, / and -";
// }
//   // Fee Type
//   if (!form.fee_type) {
//     err.fee_type = "Please select a fee type";
//   }
//   if (form.fee_type === "Other" && !form.custom_fee_type?.trim()) {
//     err.custom_fee_type = "Please enter the custom fee type";
//   } else if (form.fee_type === "Other" && form.custom_fee_type?.trim().length < 2) {
//     err.custom_fee_type = "Custom fee type must be at least 2 characters";
//   }

//   // Amount
//  // Amount
// if (!form.amount) {
//   err.amount = form.fee_type === "Other" ? "Please enter the amount" : "Please select a fee type";
// } else if (isNaN(form.amount) || Number(form.amount) <= 0) {
//   err.amount = "Amount must be a positive number";
// } else if (Number(form.amount) > 99999999) {
//   err.amount = "Amount is too large";
// }
  

//   // Payment Mode
//   if (!form.payment_mode) {
//     err.payment_mode = "Please select payment mode (DD or Cheque)";
//   }

//   // DD/Cheque Number
//   if (!form.dd_cheque_number?.trim()) {
//     err.dd_cheque_number = form.payment_mode === "DD" 
//       ? "DD number is required" 
//       : "Cheque number is required";
//   } else if (!/^[a-zA-Z0-9]+$/.test(form.dd_cheque_number.trim())) {
//     err.dd_cheque_number = "DD/Cheque number can only contain letters and numbers";
//   } else if (form.dd_cheque_number.trim().length < 6) {
//     err.dd_cheque_number = "DD/Cheque number must be at least 6 characters";
//   }

//   // DD/Cheque Date
//   if (!form.dd_date) {
//     err.dd_date = form.payment_mode === "DD" 
//       ? "DD date is required" 
//       : "Cheque date is required";
//   } else {
//     const ddDate = new Date(form.dd_date);
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);
//     if (ddDate > today) {
//       err.dd_date = "DD/Cheque date cannot be in the future";
//     }
//   }

//   // Bank Name — & IS ALLOWED
//   if (!form.bank_name?.trim()) {
//     err.bank_name = "Bank name is required";
//   } else if (form.bank_name.trim().length < 2) {
//     err.bank_name = "Bank name must be at least 2 characters";
//   }

//   // Contact Number
//   if (form.contact_number?.trim()) {
//     if (!/^[0-9]{10}$/.test(form.contact_number.trim())) {
//       err.contact_number = "Contact number must be exactly 10 digits";
//     }
//   }

//   // Remark
//   if (form.remark?.trim() && form.remark.trim().length > 500) {
//     err.remark = "Remark cannot exceed 500 characters";
//   }

//   return err;
// };

//   /* ================= SUBMIT ================= */
//   /* ================= SUBMIT ================= */
// const handleSubmit = async (e) => {
//   e.preventDefault();
  
//   // Clear previous errors
//   setErrors({});
//   setSuccessMessage("");

//   const err = validate();
//   if (Object.keys(err).length > 0) {
//     setErrors(err);
//     return;
//   }

//   try {
//    const payload = {
//   ...form,
//   fee_type: form.fee_type === "Other" ? form.custom_fee_type : form.fee_type,
// };
// delete payload.custom_amount; // no longer used

//     const url = isEdit
//       ? `${API_URL}/api/occupancy-transfer/${id}`
//       : `${API_URL}/api/occupancy-transfer`;

//     const res = await fetch(url, {
//       method: isEdit ? "PUT" : "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });

//     // Handle different HTTP status codes with specific messages
//     if (!res.ok) {
//       let errorMessage = "";

//       try {
//         const errorData = await res.json();

//         // Use server's error message if available
//         if (errorData.message) {
//           errorMessage = errorData.message;
//         } else if (errorData.error) {
//           errorMessage = errorData.error;
//         } else if (typeof errorData === "string") {
//           errorMessage = errorData;
//         } else {
//           errorMessage = JSON.stringify(errorData);
//         }
//       } catch {
//         // If response is not valid JSON
//         errorMessage = res.statusText || `Server returned ${res.status}`;
//       }

//       // Specific messages for common HTTP errors
//       if (res.status === 400) {
//         errorMessage = errorMessage || "Invalid data submitted. Please check your inputs.";
//       } else if (res.status === 401) {
//         errorMessage = "You are not authorized. Please log in again.";
//       } else if (res.status === 403) {
//         errorMessage = "You don't have permission to perform this action.";
//       } else if (res.status === 404) {
//         errorMessage = "Record not found. It may have been deleted.";
//       } else if (res.status === 409) {
//         errorMessage = errorMessage || "This record already exists (duplicate data).";
//       } else if (res.status === 422) {
//         errorMessage = errorMessage || "Validation failed. Please check your inputs.";
//       } else if (res.status === 500) {
//         errorMessage = errorMessage || "Server error. Please try again later.";
//       } else if (res.status === 503) {
//         errorMessage = "Service temporarily unavailable. Please try again later.";
//       }

//   throw new Error(errorMessage);
//     }

//     setSuccessMessage(
//       isEdit
//         ? "Receipt updated successfully ✅"
//         : "Receipt created successfully ✅"
//     );

//     if (!isEdit) setForm(getInitialForm());
    
//   } catch (err) {
//     // Network errors
//     if (err.name === "TypeError" && err.message.includes("fetch")) {
//       setErrors({ general: "Unable to connect to server. Please check your internet connection." });
//     } else {
//       setErrors({ general: err.message || "Something went wrong. Please try again." });
//     }
//   }
// };

//   if (loading) {
//     return <div className="pt-6 text-center">Loading record data...</div>;
//   }

//   return (
//     <div className="pt-6 pb-8 max-w-5xl mx-auto">
//       {/* HEADER */}
//       <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-2xl p-6 shadow mb-6">
//         <h2 className="text-2xl font-semibold">
//           {isEdit ? "Edit Occupancy Transfer" : "Occupancy Transfer Fee"}
//         </h2>
//         <p className="text-sm opacity-90 mt-1">
//           {isEdit ? "Update receipt details" : "Add Occupancy Transfer Receipt"}
//         </p>
//       </div>

//       {/* GENERAL ERROR */}
//       {errors.general && (
//         <div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-xl text-sm mb-6">
//           {errors.general}
//         </div>
//       )}

//       {/* FORM */}
//       <div className="bg-white rounded-2xl shadow p-8">
//         <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
// <Input label="Receipt No" name="receipt_no" value={form.receipt_no} onChange={handleChange}
//   placeholder="Enter receipt number" error={errors.receipt_no} required />

// <Input label="Receipt Date" type="date" name="receipt_date"
//   value={form.receipt_date} onChange={handleChange} />

// <Input label="Challan No" name="challan_no"
//   value={form.challan_no} onChange={handleChange} error={errors.challan_no} required />

// <Input label="RBI Challan No" name="rbi_challan_no"
//   value={form.rbi_challan_no} onChange={handleChange} error={errors.rbi_challan_no} />

// <Input label="Payee Name" name="payee_name"
//   value={form.payee_name} onChange={handleChange} error={errors.payee_name} required />

// <SelectField label="Fee Type" name="fee_type"
//   value={form.fee_type} onChange={handleChange} error={errors.fee_type}
//   options={["Residential", "Commercial", "Residential + Commercial", "Other"]} required />

// {form.fee_type === "Other" && (
//   <Input label="Enter Fee Type" name="custom_fee_type"
//     value={form.custom_fee_type} onChange={handleChange}
//     error={errors.custom_fee_type} required />
// )}

// {form.fee_type === "Other" ? (
//   <Input
//     label="Amount"
//     name="amount"
//     type="number"
//     min="1"
//     placeholder="Enter amount"
//     value={form.amount}
//     onChange={handleChange}
//     error={errors.amount}
//     required
//   />
// ) : (
//   <Input
//     label="Amount (auto)"
//     name="amount"
//     value={form.amount}
//     readOnly
//     error={errors.amount}
//     required
//   />
// )}

// <Input label="Amount in Words" value={form.amount_words} disabled />

// <SelectField
//   label="Payment Mode"
//   name="payment_mode"
//   value={form.payment_mode}
//   onChange={handleChange}
//   error={errors.payment_mode}
//   options={["DD", "Cheque"]}
//   required
// />

// <Input
//   label={form.payment_mode === "DD" ? "DD Number" : "Cheque Number"}
//   name="dd_cheque_number"
//   value={form.dd_cheque_number}
//   onChange={handleChange}
//   error={errors.dd_cheque_number}
//   required
// />

// <Input
//   label={form.payment_mode === "DD" ? "DD Date" : "Cheque Date"}
//   type="date"
//   name="dd_date"
//   value={form.dd_date}
//   onChange={handleChange}
//   error={errors.dd_date}
//   required
// />
//           {/* <Input 
//   label="Receipt No" 
//   name="receipt_no"
//   value={form.receipt_no} 
//   onChange={handleChange}
//   placeholder="Enter receipt number"
//   error={errors.receipt_no}
// />

//           <Input label="Receipt Date" type="date" name="receipt_date"
//             value={form.receipt_date} onChange={handleChange} />

//           <Input label="Challan No" name="challan_no"
//             value={form.challan_no} onChange={handleChange} error={errors.challan_no} />

//            <Input label="RBI Challan No" name="rbi_challan_no"
//               value={form.rbi_challan_no} onChange={handleChange} error={errors.rbi_challan_no} />

//           <Input label="Payee Name" name="payee_name"
//             value={form.payee_name} onChange={handleChange} error={errors.payee_name} />

//           <SelectField label="Fee Type" name="fee_type"
//             value={form.fee_type} onChange={handleChange}
//             options={["Residential", "Commercial", "Residential + Commercial", "Other"]} />

//           {form.fee_type === "Other" && (
//             <Input label="Enter Fee Type" name="custom_fee_type"
//               value={form.custom_fee_type} onChange={handleChange}
//               error={errors.custom_fee_type} />
//           )}

//           <SelectField label="Amount" name="amount"
//             value={form.amount} onChange={handleChange}
//             options={["40000", "60000", "Other"]} />

//           {form.amount === "Other" && (
//             <Input label="Enter Amount" name="custom_amount"
//               value={form.custom_amount} onChange={handleChange}
//               error={errors.custom_amount} />
//           )}

//           <Input label="Amount in Words" value={form.amount_words} disabled />

//           <SelectField
//             label="Payment Mode"
//             name="payment_mode"
//             value={form.payment_mode}
//             onChange={handleChange}
//             options={["DD", "Cheque"]}
//           />

//           <Input
//             label={form.payment_mode === "DD" ? "DD Number" : "Cheque Number"}
//             name="dd_cheque_number"
//             value={form.dd_cheque_number}
//             onChange={handleChange}
//             error={errors.dd_cheque_number}
//           />

//           <Input
//             label={form.payment_mode === "DD" ? "DD Date" : "Cheque Date"}
//             type="date"
//             name="dd_date"
//             value={form.dd_date}
//             onChange={handleChange}
//           /> */}

//           {/* Bank Name */}
//           <div className="space-y-1.5">
// <label className="text-sm font-medium text-gray-700">
//     Bank Name <span className="text-red-500">*</span>
//   </label>
//             <input
//               list="bank-options"
//               name="bank_name"
//               value={form.bank_name}
//               onChange={handleChange}
//               className="w-full px-4 py-2.5 rounded-xl border bg-gray-50 focus:ring-2 focus:ring-blue-500"
//             />
//             <datalist id="bank-options">
//               {[...new Set(banks)].map((b, i) => (
//                 <option key={i} value={b} />
//               ))}
//             </datalist>
//           </div>

//           <Input label="Remark" name="remark"
//             value={form.remark} onChange={handleChange} />
//             <Input label="Contact Number" name="contact_number" type="tel"
//             value={form.contact_number} onChange={handleChange} error={errors.contact_number} />

//           {/* ACTION BUTTONS */}
//           <div className="md:col-span-2 flex justify-end gap-3 pt-4">
//             <button
//               type="button"
//               onClick={() => navigate("/occupancy-add")}
//               className="px-8 py-3.5 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="px-12 py-3.5 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-medium shadow transition"
//             >
//               {isEdit ? "Update Receipt" : "Save Receipt"}
//             </button>
//           </div>
//         </form>
//       </div>

//       {/* SUCCESS MODAL */}
//       {successMessage && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-8 text-center">
//             <div className="text-5xl mb-4">✅</div>
//             <h2 className="text-xl font-semibold mb-2">Success</h2>
//             <p className="text-gray-600 mb-6">{successMessage}</p>
//             <button
//               onClick={() => setSuccessMessage("")}
//               className="px-8 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700"
//             >
//               OK
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// /* ================= REUSABLE COMPONENTS ================= */
// const Input = ({ label, error, required, ...props }) => (
//   <div className="space-y-1.5">
//     <label className="text-sm font-medium text-gray-700">
//       {label} {required && <span className="text-red-500">*</span>}
//     </label>
//     <input
//       {...props}
//       className={`w-full px-4 py-2.5 rounded-xl border bg-gray-50 focus:ring-2 focus:ring-blue-500 transition
//         ${error ? "border-red-500" : "border-gray-300"}`}
//     />
//     {error && <p className="text-red-600 text-xs mt-1">{error}</p>}
//   </div>
// );

// const SelectField = ({ label, options = [], error, required, ...props }) => (
//   <div className="space-y-1.5">
//     <label className="text-sm font-medium text-gray-700">
//       {label} {required && <span className="text-red-500">*</span>}
//     </label>
//     <select
//       {...props}
//       className="w-full px-4 py-2.5 rounded-xl border bg-gray-50 focus:ring-2 focus:ring-blue-500"
//     >
//       <option value="">Select {label}</option>
//       {options.map((opt, i) => (
//         <option key={i} value={opt}>{opt}</option>
//       ))}
//     </select>
//     {error && <p className="text-red-600 text-xs mt-1">{error}</p>}
//   </div>
// );

// export default OccupancyTransferAdd;
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

/* ================= HELPERS (must be OUTSIDE the component) ================= */
const FEE_AMOUNTS = {
  "Residential": "40000",
  "Commercial": "60000",
  "Residential + Commercial": "100000",
};

const KNOWN_FEE_TYPES = Object.keys(FEE_AMOUNTS);

const today = () => new Date().toISOString().split("T")[0];

const numberToWords = (num) => {
  if (!num) return "";
  const a = ["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
  const b = ["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];

  const inWords = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + " " + a[n % 10];
    if (n < 1000) return a[Math.floor(n / 100)] + " Hundred " + inWords(n % 100);
    if (n < 100000) return inWords(Math.floor(n / 1000)) + " Thousand " + inWords(n % 1000);
    return inWords(Math.floor(n / 100000)) + " Lakh " + inWords(n % 100000);
  };

  return (inWords(parseInt(num, 10)) + " Rupees Only").replace(/\s+/g, " ").trim();
};

const getInitialForm = () => ({
  receipt_no: "",
  receipt_date: today(),
  challan_no: "",
  rbi_challan_no: "",
  challan_date: today(),
  payee_name: "",
  fee_type: "Residential",
  custom_fee_type: "",
  amount: FEE_AMOUNTS["Residential"], // default 40000
  amount_words: numberToWords(FEE_AMOUNTS["Residential"]),
  payment_mode: "",
  dd_cheque_number: "",
  dd_date: today(),
  bank_name: "",
  contact_number: "",
  remark: "",
});

/* ================= COMPONENT ================= */
const OccupancyTransferAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const isEdit = !!id;

  const [form, setForm] = useState(getInitialForm());
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= POPULATE FORM ================= */
  const populateForm = (record) => {
    const isKnown = KNOWN_FEE_TYPES.includes(record.fee_type);

    setForm({
      ...getInitialForm(),
      receipt_no: record.receipt_no || "",
      receipt_date: record.receipt_date?.slice(0, 10) || today(),
      challan_no: record.challan_no || "",
      rbi_challan_no: record.rbi_challan_no || "",
      challan_date: record.challan_date?.slice(0, 10) || today(),
      payee_name: record.payee_name || "",
      fee_type: isKnown ? record.fee_type : "Other",
      custom_fee_type: isKnown ? "" : record.fee_type || "",
      amount: record.amount ? String(record.amount) : "",
      amount_words:
        record.amount_words || (record.amount ? numberToWords(record.amount) : ""),
      payment_mode: record.payment_mode || "",
      dd_cheque_number: record.dd_cheque_number || "",
      dd_date: record.dd_date?.slice(0, 10) || today(),
      bank_name: record.bank_name || "",
      contact_number: record.contact_number || "",
      remark: record.remark || "",
    });
  };

  /* ================= LOAD RECORD FOR EDIT ================= */
  useEffect(() => {
    if (!isEdit) return;

    const loadRecord = async () => {
      setLoading(true);

      if (location.state?.record) {
        populateForm(location.state.record);
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(`${API_URL}/api/occupancy-transfer/${id}`);
        if (!res.ok) throw new Error("Failed to fetch");
        const record = await res.json();
        populateForm(record);
      } catch (err) {
        console.error(err);
        setErrors({ general: "Failed to load record data." });
      } finally {
        setLoading(false);
      }
    };

    loadRecord();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, id]);

  /* ================= FETCH BANKS ================= */
  useEffect(() => {
    fetch(`${API_URL}/api/occupancy-transfer/banks`)
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setBanks(data);
        else setBanks([]);
      })
      .catch((err) => console.error(err));
  }, []);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...form, [name]: value };

    if (name === "fee_type") {
      if (FEE_AMOUNTS[value]) {
        // Auto-sync amount
        updated.amount = FEE_AMOUNTS[value];
        updated.amount_words = numberToWords(FEE_AMOUNTS[value]);
        updated.custom_fee_type = "";
      } else {
        // "Other" or empty: manual entry
        updated.amount = "";
        updated.amount_words = "";
      }
    }

    if (name === "amount") {
      updated.amount_words =
        value !== "" && !isNaN(value) && Number(value) > 0
          ? numberToWords(value)
          : "";
    }

    setForm(updated);

    // Clear error for this field (and the general error) when user edits
    if (errors[name] || errors.general) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        delete newErrors.general;
        return newErrors;
      });
    }
  };

  /* ================= VALIDATION ================= */
  const validate = () => {
    const err = {};

    // Receipt No
    if (!form.receipt_no?.trim()) {
      err.receipt_no = "Receipt number is required";
    } else if (!/^[a-zA-Z0-9/-]+$/.test(form.receipt_no.trim())) {
      err.receipt_no = "Receipt number can only contain letters, numbers, / and -";
    }

    // Challan No
    if (!form.challan_no?.trim()) {
      err.challan_no = "Challan number is required";
    } else if (!/^[a-zA-Z0-9/-]+$/.test(form.challan_no.trim())) {
      err.challan_no = "Challan number can only contain letters, numbers, / and -";
    }

    // RBI Challan No (optional)
    if (
      form.rbi_challan_no?.trim() &&
      !/^[a-zA-Z0-9/-]+$/.test(form.rbi_challan_no.trim())
    ) {
      err.rbi_challan_no =
        "RBI Challan number can only contain letters, numbers, / and -";
    }

    // Payee Name — & IS ALLOWED
    if (!form.payee_name?.trim()) {
      err.payee_name = "Payee name is required";
    } else if (form.payee_name.trim().length < 3) {
      err.payee_name = "Payee name must be at least 3 characters";
    } else if (form.payee_name.trim().length > 100) {
      err.payee_name = "Payee name cannot exceed 100 characters";
    } else if (!/^[a-zA-Z0-9\s.&'()-]+$/.test(form.payee_name.trim())) {
      err.payee_name =
        "Payee name contains invalid characters. Only letters, numbers, spaces, &, ., ', (, ), - are allowed";
    }

    // Fee Type
    if (!form.fee_type) {
      err.fee_type = "Please select a fee type";
    }
    if (form.fee_type === "Other") {
      if (!form.custom_fee_type?.trim()) {
        err.custom_fee_type = "Please enter the custom fee type";
      } else if (form.custom_fee_type.trim().length < 2) {
        err.custom_fee_type = "Custom fee type must be at least 2 characters";
      }
    }

    // Amount
    if (!form.amount) {
      err.amount =
        form.fee_type === "Other"
          ? "Please enter the amount"
          : "Please select a fee type";
    } else if (isNaN(form.amount) || Number(form.amount) <= 0) {
      err.amount = "Amount must be a positive number";
    } else if (Number(form.amount) > 99999999) {
      err.amount = "Amount is too large";
    }

    // Payment Mode
    if (!form.payment_mode) {
      err.payment_mode = "Please select payment mode (DD or Cheque)";
    }

    // DD / Cheque Number
    if (!form.dd_cheque_number?.trim()) {
      err.dd_cheque_number =
        form.payment_mode === "DD"
          ? "DD number is required"
          : "Cheque number is required";
    } else if (!/^[a-zA-Z0-9]+$/.test(form.dd_cheque_number.trim())) {
      err.dd_cheque_number = "DD/Cheque number can only contain letters and numbers";
    } else if (form.dd_cheque_number.trim().length < 6) {
      err.dd_cheque_number = "DD/Cheque number must be at least 6 characters";
    }

    // DD / Cheque Date
    if (!form.dd_date) {
      err.dd_date =
        form.payment_mode === "DD"
          ? "DD date is required"
          : "Cheque date is required";
    } else {
      const chosen = new Date(form.dd_date);
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      if (chosen > now) {
        err.dd_date = "DD/Cheque date cannot be in the future";
      }
    }

    // Bank Name — & IS ALLOWED
    if (!form.bank_name?.trim()) {
      err.bank_name = "Bank name is required";
    } else if (form.bank_name.trim().length < 2) {
      err.bank_name = "Bank name must be at least 2 characters";
    }

    // Contact Number (optional)
    if (form.contact_number?.trim()) {
      if (!/^[0-9]{10}$/.test(form.contact_number.trim())) {
        err.contact_number = "Contact number must be exactly 10 digits";
      }
    }

    // Remark (optional)
    if (form.remark?.trim() && form.remark.trim().length > 500) {
      err.remark = "Remark cannot exceed 500 characters";
    }

    return err;
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrors({});
    setSuccessMessage("");

    const err = validate();
    if (Object.keys(err).length > 0) {
      setErrors(err);
      return;
    }

    try {
      const payload = {
        ...form,
        fee_type:
          form.fee_type === "Other" ? form.custom_fee_type.trim() : form.fee_type,
      };
      delete payload.custom_fee_type;

      const url = isEdit
        ? `${API_URL}/api/occupancy-transfer/${id}`
        : `${API_URL}/api/occupancy-transfer`;

      const res = await fetch(url, {
        method: isEdit ? "PUT" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        let errorMessage = "";

        try {
          const errorData = await res.json();

          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.error) {
            errorMessage = errorData.error;
          } else if (typeof errorData === "string") {
            errorMessage = errorData;
          } else {
            errorMessage = JSON.stringify(errorData);
          }
        } catch {
          errorMessage = res.statusText || `Server returned ${res.status}`;
        }

        if (res.status === 400) {
          errorMessage = errorMessage || "Invalid data submitted. Please check your inputs.";
        } else if (res.status === 401) {
          errorMessage = "You are not authorized. Please log in again.";
        } else if (res.status === 403) {
          errorMessage = "You don't have permission to perform this action.";
        } else if (res.status === 404) {
          errorMessage = "Record not found. It may have been deleted.";
        } else if (res.status === 409) {
          errorMessage = errorMessage || "This record already exists (duplicate data).";
        } else if (res.status === 422) {
          errorMessage = errorMessage || "Validation failed. Please check your inputs.";
        } else if (res.status === 500) {
          errorMessage = errorMessage || "Server error. Please try again later.";
        } else if (res.status === 503) {
          errorMessage = "Service temporarily unavailable. Please try again later.";
        }

        throw new Error(errorMessage);
      }

      setSuccessMessage(
        isEdit ? "Receipt updated successfully ✅" : "Receipt created successfully ✅"
      );

      if (!isEdit) setForm(getInitialForm());
    } catch (err) {
      if (err.name === "TypeError") {
        setErrors({
          general: "Unable to connect to server. Please check your internet connection.",
        });
      } else {
        setErrors({ general: err.message || "Something went wrong. Please try again." });
      }
    }
  };

  if (loading) {
    return <div className="pt-6 text-center">Loading record data...</div>;
  }

  return (
    <div className="pt-6 pb-8 max-w-5xl mx-auto">
      {/* HEADER */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-2xl p-6 shadow mb-6">
        <h2 className="text-2xl font-semibold">
          {isEdit ? "Edit Occupancy Transfer" : "Occupancy Transfer Fee"}
        </h2>
        <p className="text-sm opacity-90 mt-1">
          {isEdit ? "Update receipt details" : "Add Occupancy Transfer Receipt"}
        </p>
      </div>

      {/* GENERAL ERROR */}
      {errors.general && (
        <div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-xl text-sm mb-6">
          {errors.general}
        </div>
      )}

      {/* FORM */}
      <div className="bg-white rounded-2xl shadow p-8">
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="Receipt No"
            name="receipt_no"
            value={form.receipt_no}
            onChange={handleChange}
            placeholder="Enter receipt number"
            error={errors.receipt_no}
            required
          />

          <Input
            label="Receipt Date"
            type="date"
            name="receipt_date"
            value={form.receipt_date}
            onChange={handleChange}
          />

          <Input
            label="Challan No"
            name="challan_no"
            value={form.challan_no}
            onChange={handleChange}
            error={errors.challan_no}
            required
          />

          <Input
            label="RBI Challan No"
            name="rbi_challan_no"
            value={form.rbi_challan_no}
            onChange={handleChange}
            error={errors.rbi_challan_no}
          />

          <Input
            label="Payee Name"
            name="payee_name"
            value={form.payee_name}
            onChange={handleChange}
            error={errors.payee_name}
            required
          />

          <SelectField
            label="Fee Type"
            name="fee_type"
            value={form.fee_type}
            onChange={handleChange}
            error={errors.fee_type}
            options={["Residential", "Commercial", "Residential + Commercial", "Other"]}
            required
          />

          {form.fee_type === "Other" && (
            <Input
              label="Enter Fee Type"
              name="custom_fee_type"
              value={form.custom_fee_type}
              onChange={handleChange}
              error={errors.custom_fee_type}
              required
            />
          )}

          {form.fee_type === "Other" ? (
            <Input
              label="Amount"
              name="amount"
              type="number"
              min="1"
              placeholder="Enter amount"
              value={form.amount}
              onChange={handleChange}
              error={errors.amount}
              required
            />
          ) : (
            <Input
              label="Amount (auto)"
              name="amount"
              value={form.amount}
              readOnly
              error={errors.amount}
              required
            />
          )}

          <Input label="Amount in Words" value={form.amount_words} disabled />

          <SelectField
            label="Payment Mode"
            name="payment_mode"
            value={form.payment_mode}
            onChange={handleChange}
            error={errors.payment_mode}
            options={["DD", "Cheque"]}
            required
          />

          <Input
            label={form.payment_mode === "DD" ? "DD Number" : "Cheque Number"}
            name="dd_cheque_number"
            value={form.dd_cheque_number}
            onChange={handleChange}
            error={errors.dd_cheque_number}
            required
          />

          <Input
            label={form.payment_mode === "DD" ? "DD Date" : "Cheque Date"}
            type="date"
            name="dd_date"
            value={form.dd_date}
            onChange={handleChange}
            error={errors.dd_date}
            required
          />

          {/* Bank Name */}
          <div className="space-y-1.5">
            <label className="text-sm font-medium text-gray-700">
              Bank Name <span className="text-red-500">*</span>
            </label>
            <input
              list="bank-options"
              name="bank_name"
              value={form.bank_name}
              onChange={handleChange}
              className={`w-full px-4 py-2.5 rounded-xl border bg-gray-50 focus:ring-2 focus:ring-blue-500 transition
                ${errors.bank_name ? "border-red-500" : "border-gray-300"}`}
            />
            <datalist id="bank-options">
              {[...new Set(banks)].map((b, i) => (
                <option key={i} value={b} />
              ))}
            </datalist>
            {errors.bank_name && (
              <p className="text-red-600 text-xs mt-1">{errors.bank_name}</p>
            )}
          </div>

          <Input
            label="Remark"
            name="remark"
            value={form.remark}
            onChange={handleChange}
            error={errors.remark}
          />

          <Input
            label="Contact Number"
            name="contact_number"
            type="tel"
            value={form.contact_number}
            onChange={handleChange}
            error={errors.contact_number}
          />

          {/* ACTION BUTTONS */}
          <div className="md:col-span-2 flex justify-end gap-3 pt-4">
            <button
              type="button"
              onClick={() => navigate("/occupancy-add")}
              className="px-8 py-3.5 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-12 py-3.5 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-medium shadow transition"
            >
              {isEdit ? "Update Receipt" : "Save Receipt"}
            </button>
          </div>
        </form>
      </div>

      {/* SUCCESS MODAL */}
      {successMessage && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-8 text-center">
            <div className="text-5xl mb-4">✅</div>
            <h2 className="text-xl font-semibold mb-2">Success</h2>
            <p className="text-gray-600 mb-6">{successMessage}</p>
            <button
              onClick={() => setSuccessMessage("")}
              className="px-8 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

/* ================= REUSABLE COMPONENTS ================= */
const Input = ({ label, error, required, ...props }) => (
  <div className="space-y-1.5">
    <label className="text-sm font-medium text-gray-700">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <input
      {...props}
      className={`w-full px-4 py-2.5 rounded-xl border bg-gray-50 focus:ring-2 focus:ring-blue-500 transition
        ${error ? "border-red-500" : "border-gray-300"}`}
    />
    {error && <p className="text-red-600 text-xs mt-1">{error}</p>}
  </div>
);

const SelectField = ({ label, options = [], error, required, ...props }) => (
  <div className="space-y-1.5">
    <label className="text-sm font-medium text-gray-700">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <select
      {...props}
      className={`w-full px-4 py-2.5 rounded-xl border bg-gray-50 focus:ring-2 focus:ring-blue-500 transition
        ${error ? "border-red-500" : "border-gray-300"}`}
    >
      <option value="">Select {label}</option>
      {options.map((opt, i) => (
        <option key={i} value={opt}>
          {opt}
        </option>
      ))}
    </select>
    {error && <p className="text-red-600 text-xs mt-1">{error}</p>}
  </div>
);

export default OccupancyTransferAdd;